<template lang='pug'>
  include ../mixins
  row.ma--top_3sm(space="2sm")
    cell.ma--bottom_md-till-md(cols="12 narrow-md 4-lg 6-xl 4-xxl")
      template(v-if="formatTestDaysArray.length")
        bem-text.ma--bottom_sm(
          tag="h2"
          weight="semi-bold"
          size="3sm"
          height="xs"
        ) {{_('Выберите дату')}}
        v-calendar.ls-calendar(
          :available-dates="formatTestDaysArray"
          :first-day-of-week="2"
          :locale="locale"
          @dayclick="getTestTime($event)"
          is-expanded
        )
      template(v-else)
        bem-text.ma--bottom_sm(
          tag="p"
          size="sm"
          height="xs"
          weight="semi-bold"
        ) {{_('По выбранным параметрам нет свободных мест')}}
    cell(cols="12 auto-md 6-xl 8-xxl" v-if="timeSlotsList.length > 0 && isShowSlots")
      row
        cell(cols="12 auto-sm")
          bem-text.ma--bottom_sm(
            tag="h2"
            weight="semi-bold"
            size="3sm"
            height="xs"
          ) {{_('Выберите время')}}
        cell(cols="12 narrow-sm")
          bem-text.ma--bottom_sm(
            tag="p"
            size="3sm"
            height="xs"
          ) {{ dateString }}
      validation-provider(
        tag="div"
        v-slot="{errors}"
        name="slot"
        :rules="{ required: { allowFalse: false } }"
      )
        +b.ls-card--color_light-2.--space_3sm.--border_3sm
          row(space="sm-sm")
            cell.ma--bottom_sm(
              cols="12 6-sm 12-xl 6-mac 4-xxl"
              v-for="(item, index) in timeSlotsList"
              :key="index"
            )
              +b.time-slot.pos--relative
                row(align="center")
                  cell(cols="3 4-lg")
                    bem-text(
                      tag="p"
                      weight="semi-bold"
                      size="3sm"
                    ) {{ item.time }}
                  cell(cols="9 8-lg")
                    input(
                      type="radio"
                      v-model="formdata.slot"
                      :value="item.id"
                      :id="item.id"
                      @change="formdata.timeSlot = item.time"
                    )
                    label(:for="item.id") {{_('Забронювати')}}
          +b.P.ls-text--color_error.--size_3xs(v-if="errors[0]") {{ errors[0] }}

</template>

<script>
import moment from 'moment'
import 'vue2-datepicker/locale/en'
import 'vue2-datepicker/locale/ru'
import 'vue2-datepicker/locale/uk'

import {
  slotsListResource,
} from '@/js/services/additional.service.js'

export default {
  name: 'date-form',
  props: {
    formdata: Object,
    testDaysList: Array,
  },
  data() {
    return {
      locale: window.language,
      formatTestDaysArray: [],
      dateString: '',
      timeSlotsList: [],
      isShowSlots: false,
    }
  },
  watch: {
    testDaysList: {
      handler(nval) {
        if (null !== nval) this.formatArray(nval)
        this.isShowSlots = false
      },
      deep: true,
    },
    'formdata.dateSlot': {
      handler(nval) {
        if (null === nval) this.timeSlotsList = []
      },
    },
  },
  methods: {
    formatArray(arr) {
      this.formatTestDaysArray = arr.map(item => {
        const { date } = item
        const day = moment(date, 'YYYY.MM.DD').format('MM/DD/YYYY')
        return {
          start: new Date(day),
          end: new Date(day),
        }
      })
    },
    getTestTime(date) {
      this.dateString = date.ariaLabel
      this.formdata.dateSlot = date.id
      const idAgeGroup = this.formdata.ageGroup.id
      const idSchool = this.formdata.school.id
      return slotsListResource.execute({}, { idSchool, idAgeGroup, date: date.id })
        .then(({ data: { item: { items } } }) => {
          this.timeSlotsList = items
          this.isShowSlots = true
        })
    },
  },
}
</script>
